// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import MintUI from 'mint-ui'
import axios from 'axios'
import 'mint-ui/lib/style.css'
import './assets/css/app.css'
import './assets/iconfont/iconfont.css'
import store from './store'
import router from './router'
import filter from './filter.js'
import util from './util.js'
import Vuex from 'vuex'
import Vconsole from 'vconsole'
import i18n from '../src/assets/js/i18n/language' //获取默认语言

var moment = require('moment')

Vue.use(Vuex)
axios.defaults.withCredentials = true // 让ajax携带cookie
let instance = axios.create()

// Add a request interceptor
instance.interceptors.request.use(function (config) {
    // Do something before request is sent
    return config
}, function (error) {
    // Do something with request error
    return Promise.reject(error)
})

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    // Do something with response data
    return response
}, function (error) {
    // Do something with response error
    return Promise.reject(error)
})

/* 设置storeId cookie */
var GetQueryString = function (name) {
    var index = window.location.href.indexOf('?')
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.href.substr(index + 1).match(reg)
    if (r != null) return unescape(r[2])
    return null
}

/* 如果再店铺中用户已登录未退出，打开其他店铺地址，需要重新登录 */
// let inStore = /^share/.test(window.location.host)
// if (inStore) {
//     console.log('--------')
//     instance.post('/ms/baseInfo').then((res) => {
//         if (res.data.status === 100000) {
//             router.push({ path: '/form-login' })
//         }
//     })
// }

/* 设置cookie storeId */
const storeId = util.getUrlParam('storeId')
if (storeId) {
    document.cookie = `storeId=${storeId};path=/;`
}

/* 注册axios实例 */
Vue.prototype.$http = instance

/* 注册过滤器 */
for (const key in filter) {
    if (filter.hasOwnProperty(key)) {
        const element = filter[key]
        Vue.filter(key, element)
    }
}

Vue.use(MintUI)

// 设置title指令
Vue.directive('title', {
    update: (el, binding) => {
        document.title = binding.value
    }
})

Vue.config.productionTip = false
/* 手机系统和型号判断 */
let phoneInfo = util.phoneInfo()
store.commit('initPhone', phoneInfo)

/**
 * 判断当前设备屏幕宽带是否大于768px, 如果大于设置768px
 */
let mdWidth = 0
if (document.documentElement.clientWidth >= 768 + 17) {
    mdWidth = (document.documentElement.clientWidth - 17 - 768) / 2
}
store.commit('initScreen', mdWidth)

/**
 * 设置 rem font-size
 */
window.addEventListener('resize', util.updateBaseFontSize)
util.updateBaseFontSize()

/* 开启同行密码访问 */
var getBaseInfo = function () {
    instance.get('/ms/baseInfo').then(async res => {
        await store.dispatch('saveSiteInfo', res.data.data)
        if (store.getters.getSiteInfo.weiXinIsNoPass === 1 && !util.getCookie('peer_login_token')) {
            router.push('/peer-form-login')
            routerBefore()
        } else {
            routerBefore()
        }
    })
}
getBaseInfo()
window.sessionStorage.setItem('url', window.location.href)

/* 当erpId为1的时候，展示console */
instance.get('/ms/baseInfo').then(res => {
    const erpId = res.data.data.erpID
    localStorage.setItem("$erpId",erpId)
    if (erpId === 1 || erpId === 4) {
        let vConsole = new Vconsole()
        Vue.prototype.$console = vConsole
    }
    if (erpId === 5 || erpId === 2297) {
        var _hmt = _hmt || [];
        (function () { var hm = document.createElement("script"); hm.src = "https://hm.baidu.com/hm.js?7d4dba1d3f7efba9110cbd2653a2b38f"; var s = document.getElementsByTagName("script")[0]; s.parentNode.insertBefore(hm, s) })()
    }
})

var routerBefore = function () {
    router.beforeEach((to, from, next) => {
        const inStore = /(share)/.test(window.location.origin)
        const drpLogin = util.getCookie('xqapp_web_login_id')
        const storeLogin = util.getCookie('store_login_id')
        // 设置分享url
        window.sessionStorage.setItem('url', null)

        // 如果当前路由需要登录权限，判断用户是否登录
        if (to.matched.some(item => item.meta.requireAuth)) {
            // 用户在微站已登录
            if (!inStore && drpLogin) {
                // 如果没有用户信息，请求并保存用户信息
                if (!Object.keys(store.getters.getUser).length) {
                    // 如果已登录，不存在用户信息，请求用户信息
                    instance.get('/ms/user/info', {
                        emulateJSON: true
                    }).then(res => {
                        if (res.data.status == 100000){
                            util.clearCookie('xqapp_web_login_id')
                            // 用户未登录，跳转至登录页
                            next({path: '/form-login', query: {redirect: to.fullPath}})
                        }else{
                            store.commit('saveUser', res.data.data)
                            next()
                        }

                    })
                } else {
                    next()
                }
            } else if (inStore && storeLogin) {
                // 用户在店铺已登录
                if (!Object.keys(store.getters.memberInfo).length) {
                    // 如果已登录，不存在用户信息，请求用户信息
                    instance.get('/store/member/info').then(res => {
                        if (res.data.status === 200) {
                            let result = res.data.data
                            if (result) {
                                if (!result.birth) {
                                    result.birth = moment().format('YYYY-MM-DD')
                                } else {
                                    result.birth = moment(result.birth).format('YYYY-MM-DD')
                                }
                                store.commit('saveMemberInfo', result)
                            }
                        }else if (res.data.status == 100000){
                            util.clearCookie('store_login_id')
                        }
                        next()
                    })
                } else {
                    next()
                }
                next()
            } else {
                // 用户未登录，跳转至登录页
                next({path: '/form-login', query: {redirect: to.fullPath}})
            }
        } else {
            // 如果当前路由不需要登录
            next()
        }
    })
}
// test

/* eslint-disable no-new */
const $vue = new Vue({
    el: '#app',
    router,
    store,
    i18n, // 注入
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js